import AdminDashboard from '../components/AdminDashboard';

const AdminDashboardPage = () => {
  return (
    <div className="admin-dashboard-page">
      <AdminDashboard />
    </div>
  );
};

export default AdminDashboardPage;

